import map from 'lodash/fp/map';
import { toShortSemanticVersion } from '~/features/base/utils/versionNumberConverter';

export const parseBaseSwVersion = baseSwVersion => ({
    softwareVersion: baseSwVersion,
    shortBaseSwVersion: toShortSemanticVersion(baseSwVersion),
});
export const parseBaseSwVersions = baseSwVersions => map(parseBaseSwVersion, baseSwVersions);
